import { styled } from 'styled-components';

export const Col = styled.div<{
  $align?: 'left' | 'right';
  $showWarning?: boolean;
}>(({ theme, $align = 'left', $showWarning = false }) => ({
  textAlign: $align,
  '& *:not(:first-of-type)': {
    display: 'block',
    fontStyle: 'italic',
    paddingTop: '16rem',
  },
  color: $showWarning ? theme.palette.red : 'inherit',
}));

export const Row = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: '3fr 1fr 2fr',
  padding: '10rem',
  gap: '4rem',
}));

export const Container = styled.div(({ theme }) => ({
  overflowY: 'auto',
  [`${Row}:nth-child(odd)`]: {
    backgroundColor: theme.palette.concrete,
  },
  [`${Row}:last-of-type`]: {
    paddingBottom: '24rem',
  },

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));

export const Note = styled.div(() => ({
  gridColumn: '1 / -1',
  marginTop: '4rem',
  fontStyle: 'italic',
}));
